module.exports = __webpack_public_path__ + "static/media/fonzie-bg_thumbnail.a2ee0376.jpg";